module.exports = __webpack_public_path__ + "static/media/reflex.6abd79dc.png";